//format DD-MM-YYYY
import React from 'react';

export default function DatePicker({ value, onChange }) {
    const [day, month, year] = value ? value.split('-') : ['', '', ''];

    return (
        <div>
            <select
                value={day}
                onChange={(e) =>
                    onChange([e.target.value || 'DD', month || 'MM', year || 'YYYY'].join('-'))
                }
            >
                <option value="">Day</option>
                {Array.from({ length: 31 }, (_, i) => (
                    <option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                        {String(i + 1).padStart(2, '0')}
                    </option>
                ))}
            </select>
            <select
                value={month}
                onChange={(e) =>
                    onChange([day || 'DD', e.target.value || 'MM', year || 'YYYY'].join('-'))
                }
            >
                <option value="">Month</option>
                {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                        {String(i + 1).padStart(2, '0')}
                    </option>
                ))}
            </select>
            <select
                value={year}
                onChange={(e) =>
                    onChange([day || 'DD', month || 'MM', e.target.value || 'YYYY'].join('-'))
                }
            >
                <option value="">Year</option>
                {Array.from({ length: 100 }, (_, i) => {
                    const yearOption = new Date().getFullYear() - i;
                    return (
                        <option key={yearOption} value={yearOption}>
                            {yearOption}
                        </option>
                    );
                })}
            </select>
        </div>
    );
}